import script from "./Group.vue?vue&type=script&lang=ts&setup=true"
export * from "./Group.vue?vue&type=script&lang=ts&setup=true"

import "./Group.vue?vue&type=style&index=0&id=aeb6f8f2&lang=scss"

const __exports__ = script;

export default __exports__